<script lang="ts">
	import { Button } from "@ishavskraft/shared";
	import { page } from "$app/state";
	import Breadcrumb from "#lib/Breadcrumb.svelte";

	const filterList = [
		{ label: "Aktuelt", href: "/om/aktuelt" },
		{ label: "Sparetips", href: "/om/aktuelt/sparetips" },
	];
	let {
		children,
	}: {
		children?: import("svelte").Snippet;
	} = $props();
	let filterLinks = $derived(
		filterList.map((x) => ({
			...x,
			active: x.href === (page.url.pathname || ""),
		}))
	);
	let activeLink = $derived.by(() => {
		const active = filterLinks.find((x) => x.active);
		return active ?? filterLinks[0];
	});
</script>

<Breadcrumb
	breadcrumbs={[
		{ label: "Forside", href: "/" },
		{ label: "Aktuelt", href: "/om/aktuelt" },
		...(activeLink.href !== "/om/aktuelt"
			? [{ label: activeLink?.label, href: activeLink?.href }]
			: []),
	]}
/>

<div class="flex justify-between children-my-0 mt-2 mb-5 overflow-x-auto px-edge-x gap-2 text-base">
	<ul class="list-none flex gap-2 p-0">
		{#each filterLinks as link (link)}
			<li>
				<a
					data-sveltekit-reset="false"
					class="button whitespace-nowrap px-3"
					class:button-selected={link.active}
					class:button-primary={!link.active}
					href={link.href}
				>
					{link.label}
				</a>
			</li>
		{/each}
	</ul>

	<p class="text-end">
		<Button href="/sok" arrow class="whitespace-nowrap">Søk i artikler</Button>
	</p>
</div>

{@render children?.()}
